// extracted by mini-css-extract-plugin
export default {"container":"L0lPxL","content":"RhpzaQ","imageContainer":"H26QW3","image":"q9wTX9","pill":"k4DSAU","list":"NT6C09","quoteTitle":"QCTJoP","blockquote":"CEjH5t","ctaContainer":"B50vv4"};